module.exports = __webpack_public_path__ + "img/bg-open_lecture.18da12e8.jpg";